module.exports = __webpack_public_path__ + "static/media/guiltyformen.346ce971.png";